module.exports = __webpack_public_path__ + "img/framenew_box19.55202951.jpg";